import { render } from "./PrintBillButtonComponent.vue?vue&type=template&id=238f2702"
import script from "./PrintBillButtonComponent.vue?vue&type=script&lang=js"
export * from "./PrintBillButtonComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__